export const authConstants = {
     AUTH_LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
     AUTH_LOGIN_COMPLETE: "AUTH_LOGIN_COMPLETE",
     AUTH_LOGOUT_REQUEST: "AUTH_LOGOUT_REQUEST",
     AUTH_LOGOUT_COMPLETE: "AUTH_LOGOUT_COMPLETE",

     AUTH_USER_PROFILE_DEATAILS_REQUEST: "AUTH_USER_PROFILE_DEATAILS_REQUEST",
     AUTH_USER_PROFILE_DEATAILS_COMPLETE: "AUTH_USER_PROFILE_DEATAILS_COMPLETE",

     AUTH_GET_REFRESH_TOKEN_REQUEST: "AUTH_GET_REFRESH_TOKEN_REQUEST",
     AUTH_GET_REFRESH_TOKEN_COMPLETE: "AUTH_GET_REFRESH_TOKEN_COMPLETE",

     PRE_REGISTRATION_REQUEST: "PRE_REGISTRATION_REQUEST",
     PRE_REGISTRATION_COMPLETE: "PRE_REGISTRATION_COMPLETE",

     PRE_REGISTRATION_ACTIVATE_REQUEST: "PRE_REGISTRATION_ACTIVATE_REQUEST",
     PRE_REGISTRATION_ACTIVATE_COMPLETE: "PRE_REGISTRATION_ACTIVATE_COMPLETE",

     SEND_OTP_REQUEST: "SEND_OTP_REQUEST",
     SEND_OTP_COMPLETE: "SEND_OTP_COMPLETE",

     RE_SEND_OTP_REQUEST: "RE_SEND_OTP_REQUEST",
     RE_SEND_OTP_COMPLETE: "RE_SEND_OTP_COMPLETE",

     FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST:
          "FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST",
     FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE:
          "FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE",

     FORGOT_PASSWORD_RESET_PASSWORD_REQUEST:
          "FORGOT_PASSWORD_RESET_PASSWORD_REQUEST",
     FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE:
          "FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE",

     USER_DETAILS_REQUEST:"USER_DETAILS_REQUEST",
     USER_DETAILS_COMPLETE:"USER_DETAILS_COMPLETE",
};

export const cookieConstants = {
    USER_DETAILS_COOKIE: "user",
    IS_LOGGED_IN: "is-logged-in",
    USER_NAME: "user_name",
};

export const otpTypeConstants = {
     AUTH_TYPE_LOGIN: 1,
     AUTH_TYPE_FOGOT_PASSWORD: 2,
     AUTH_TYPE_ACCOUNT_ACTIVATION: 4,
     AUTH_TYPE_CHANGE_PASSWORD: 5,
     AUTH_TYPE_CHANGE_MOBILE_NUMBER: 5,
     AUTH_TYPE_ADD_ACCOUNT: 5,
};

export const participantJobRoleIds = {
     PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER: 15,
     PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR: 14,
     PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER: 20,
     TLC_PARTICIPANT_CUSTOMER: 21,
     TLC_PARTICIPANT_AREA_MANAGER: 22,
};


